// extracted by mini-css-extract-plugin
module.exports = {"alerts":"alerts_alerts__8r7J6","alert":"alerts_alert__Bl8JE"};